import { RootStateType } from 'base/store/rootStore';
import cn from 'classnames';

export function getBodyClass(state: RootStateType): string {
    const { lang, ua, bodyClassName, pageCode, query } = state;
    const client = ua.isPhone ? 'm' : (ua.isTablet ? 'pad' : 'pc');
    return cn(
        bodyClassName,
        `g-body-${lang} g-body-${client}`,
        { 'g-body-app': ua.isApp },
        pageCode === 'help' && query.code ? `g-body-${query.code}` : ''
    );
}

export function appendPageCss(pathname: string) {
    if (process.env.NODE_ENV !== 'production') {
        const head = document.getElementsByTagName('head')[0];
        let link = document.getElementById('page-css') as HTMLLinkElement;
        if (!link) {
            link = document.createElement('link');
            link.id = 'page-css';
            link.rel = 'stylesheet';
            link.type = 'text/css';
        }
        link.href = `/_next/static/css/pages${pathname === '/' ? '/index' : pathname}.css?v=${Date.now()}`;
        head.appendChild(link);
    }
}